import { bff_prefix } from '@/consts';
import { forumuser } from '@/typings/open.platform.forum_bff';
import { request } from '@/utils/request';

const prefix = `${bff_prefix}/forumUser`;
class Service {
  async getUserInfo(req: forumuser.GetUserRequest) {
    const res = await request<
      forumuser.GetUserRequest,
      forumuser.GetUserResponseData
    >({
      url: `${prefix}/getUser`,
      params: req,
    });
    return res.data;
  }

  async getUserHome(req: forumuser.GetUserHomeRequest) {
    const res = await request<
      forumuser.GetUserHomeRequest,
      forumuser.GetUserHomeResponseData
    >({
      url: `${prefix}/getUserHome`,
      params: req,
    });
    return res.data;
  }

  async getUserById(req: forumuser.GetUserByIdRequest) {
    const res = await request<
      forumuser.GetUserByIdRequest,
      forumuser.GetUserByIdResponseData
    >({
      url: `${prefix}/getUserById`,
      params: req,
    });
    return res.data;
  }

  async updateBlockStateByUid(req: forumuser.UpdateBlockStateByUidRequest) {
    const res = await request<
      forumuser.UpdateBlockStateByUidRequest,
      forumuser.UpdateBlockStateByUidResponseData
    >({
      url: `${prefix}/updateBlockStateByUid`,
      method: 'POST',
      data: req,
    });
    return res.data;
  }

  async toggleFollow(req: forumuser.ToggleFollowRequest) {
    const res = await request<
      forumuser.ToggleFollowRequest,
      forumuser.ToggleFollowResponseData
    >({
      url: `${prefix}/toggleFollow`,
      method: 'POST',
      data: req,
    });
    return res.data;
  }

  async getPosts(req: forumuser.GetPostsRequest) {
    const res = await request<
      forumuser.GetPostsRequest,
      forumuser.GetPostsResponseData
    >({
      url: `${prefix}/getPosts`,
      method: 'GET',
      params: req,
    });
    return res.data;
  }

  async getReplies(req: forumuser.GetRepliesRequest) {
    const res = await request<
      forumuser.GetRepliesRequest,
      forumuser.GetRepliesResponseData
    >({
      url: `${prefix}/getReplies`,
      method: 'GET',
      params: req,
    });
    return res.data;
  }

  async getComment(req: forumuser.GetCommentsRequest) {
    const res = await request<
      forumuser.GetCommentsRequest,
      forumuser.GetCommentsResponseData
    >({
      url: `${prefix}/getComments`,
      method: 'GET',
      params: req,
    });
    return res.data;
  }
}

export const forumUserService = new Service();
